import StopWatch from "./Components/Stopwatch";
import React from "react";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <h1> विराम घड़ी </h1>

      <StopWatch />
    </div>
  );
}
